// extracted by mini-css-extract-plugin
export default {"Outer":"page-not-found_Outer__SZg+H","ImageOuter":"page-not-found_ImageOuter__riB4d"};